/**
 * Converts a distance in kilometres to a distance in miles.
 *
 * @param {number} km The distance in kilometres to convert.
 * @return {number} The distance in miles.
 * @example
 * const km = 10;
 * const mi = convertKilometresToMiles(km);
 * console.log(mi); // 6.21371
 */
export function convert_kilometres_to_miles (km: number): number {
  return km * 0.621371
}


/**
 * Converts a distance in kilometres to a distance in yards.
 *
 * @param {number} km The distance in kilometres to convert.
 * @return {number} The distance in yards.
 * @example
 * const km = 10;
 * const y = convert_kilometres_to_yards(km);
 * console.log(y); // 10936.13298
 */
export function convert_kilometres_to_yards (km: number): number {
  return km * 1093.613298
}

/**
 * Converts a distance in kilometres to a distance in meters.
 *
 * @param {number} km The distance in kilometres to convert.
 * @return {number} The distance in meters.
 * @example
 * const km = 10;
 * const m = convert_kilometres_to_meters(km);
 * console.log(m); // 10000
 */
export function convert_kilometres_to_meters (km: number): number {
  return km * 1000
}
